import React, { memo, useContext, useEffect, useState } from 'react';
import themeContext from '../../context/theme/themeContext';
import { useWeb3React } from '@web3-react/core';
import { formatAccount } from '../../helpers/formats';
import modalContext from '../../context/modal/modalContext';
import { DarkThemeIcon, LightThemeIcon, WalletIcon } from '../../assets/icons';
import { UAuthConnector } from '@uauth/web3-react';
import errorContext from '../../context/error/errorContext';
import ChainSelector from './ChainSelector';
import { SupportedChains } from '../../config/constants';

const AccountDetails: React.FC = () => {
    const { toggleTheme } = useContext(themeContext);

    const { openModal } = useContext(modalContext);

    const { setError } = useContext(errorContext);

    const { chainId, account, connector } = useWeb3React();

    const [userDomain, setUserDomain] = useState('');

    // state to prevent account address from appearing first
    // const [loadingReverseResolution, setLoadingReverseResolution] =
    //     useState<boolean>(false);

    useEffect(() => {
        // reset user domain when user switches wallet
        if (!account) {
            setUserDomain('');
            return;
        }

        //  Account still exists, but it is recommended to show the domain name so that user's know for sure they are logged in
        if (connector instanceof UAuthConnector) {
            (async () => {
                try {
                    const user = await (connector as any).uauth.user();
                    setUserDomain(user.sub);
                } catch (error) {
                    setError(error);
                }
            })();
            return;
        }

        // TODO: some issue with getting user domain name, commented for now
        // get Unstoppable Domain domain
        // (async () => {
        //     try {
        //         setLoadingReverseResolution(true);
        //         const domainName = await reverseUrl(account);

        //         if (!domainName) return;
        //         setUserDomain(domainName);
        //     } catch (error) {
        //         setError(error);
        //     } finally {
        //         setLoadingReverseResolution(false);
        //     }
        // })();
    }, [account, connector, setError]);

    return (
        <div className='header__right'>
            <div className='switch-container'>
                <span>Select mode:</span>
                <div className='switch' onClick={toggleTheme}>
                    <LightThemeIcon />
                    <DarkThemeIcon />
                </div>
            </div>
            <ChainSelector />
            <div className='wallet' onClick={() => openModal('connectWalletModal')}>
                <WalletIcon />
                <span className={account ? 'connected' : ''}>
                    {account && userDomain && chainId !== SupportedChains.ARBITRUM_ONE
                        ? formatAccount(userDomain)
                        : account
                        ? formatAccount(account)
                        : 'Connect Wallet'}
                </span>
            </div>
        </div>
    );
};

export default memo(AccountDetails);
